import React, { useRef, useState } from "react"
import ChartBox from "../components/Charts/ChartBox"
import {GenerateTestData} from "../components/Charts/chartHelpers"
import {useSkidsWithConfig, useSkidsWithConfigDispatch} from '../components/AvailableSkids/skidsWithConfigProvider'
import {useTracker, useTrackerDispatch} from '../components/FetchTracker/FetchTrackerProvider'
import HistoricSelector from '../components/Historic/HistoricSelector'
import { useLocation } from 'react-router-dom';
import {DataPoint} from './Historic'
import {getTZoffesetFromTZ} from '../Helper/timeHelpers';
import { useSkidConfig } from "../components/AvailableSkids/SkidsProvider"
import Displaybox from "../components/Display/DisplayBox"
import Focused from "../components/Display/Focused"
interface LocationState{
    targetSkid: string
}

function ChartDev(){
    const locationState = useLocation().state as LocationState;
        var targetSkid = locationState?.targetSkid
        if (!targetSkid){
            targetSkid = ''
        }
    const [data, setData] = useState([])
    const  dataGenRef = useRef(false)
    const skidsWithConfig = useSkidsWithConfig()
    const skidsWithConfigDispatch = useSkidsWithConfigDispatch()
    const skids = useSkidConfig()
    const Tracker = useTracker()  
    const TrackerDispatch = useTrackerDispatch()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [skid, setSkid] = useState(targetSkid);
    const [message,setMessage] = useState('Select Skid to get Started')
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    if (skidsWithConfig.has(skid)){
        tz = skidsWithConfig.get(skid).timezone
        if (!tz){
            tz = 'UTC'
        }
    }
    const [timezone, setTimezone] = useState(tz)
    const tzOffset = getTZoffesetFromTZ(timezone)*1000
    const oldTzOffsetref = useRef(tzOffset)
    console.log("tz:",timezone)
    console.log("tz:offset:",tzOffset)
    var startUTC = Date.now()-8*3600*1000
    var endUTC = Date.now()
    console.log("Start:",startUTC,"UTC:",new Date(startUTC).toUTCString(),"Local:",new Date(startUTC).toLocaleString())
    console.log("End:",startUTC,"UTC:",new Date(endUTC).toUTCString(),"Local:",new Date(endUTC).toLocaleString())
    var startTZ = startUTC+tzOffset
    var endTZ = endUTC+tzOffset
    console.log("Start:",startUTC,"UTC:",new Date(startTZ-tzOffset).toUTCString(),"TZ:",new Date(startTZ).toUTCString())
    console.log("End:",startUTC,"UTC:",new Date(endTZ-tzOffset).toUTCString(),"TZ:",new Date(endTZ).toUTCString())
    const [startTime, setStartTime] = useState(startTZ)
    const [endTime, setEndTime] = useState(endTZ)
    console.log("startTime:",startTime)
    console.log("endTime:",endTime)
    const lastData = data[data.length-1]
    console.log("last datapoint: ",lastData)
    /* if(dataGenRef.current === false){
        dataGenRef.current = true
        const newData = GenerateTestData(60, new Date('2024-01-01T00:00:00Z'), new Date('2024-01-02T00:00:00Z'), ['a_3rpm_e','PV','Temp'])
        setData(newData)
    }
    console.log('data:',data) */

    function handleFetchResp(resp:Promise<Response>){
            resp.then(res => res.json()).then((items:DataPoint[])=>{
                setData(items)
                setLoading(false)
            }).catch((error)=>{
                setError(error)
            })  
        }
    return (
        <div style={{display:'flex', flexDirection:'row'}}>
            <div style={{display:'flex', flexDirection:'column', flexGrow:4}}>
            <HistoricSelector setLoading={setLoading} dataHandler={handleFetchResp} 
            setSkid={setSkid} skid={skid} 
            start={startTime} setStart={setStartTime}
            end={endTime} setEnd={setEndTime}
            timezone={timezone} setTimezone={setTimezone}
            setMessage={setMessage} 
            skids={skids}
            skidsWithConfig={skidsWithConfig} />
            
            <ChartBox data={data} skids={skidsWithConfig} skid={skid} options={{horizontal:true}} />
            </div>
            
           {lastData &&
             <Focused data={lastData} tags={['t_inlet_m','rho_e_m' ]}/>
           }
           
            
                  
        </div>
    ) 
}
export default ChartDev